<!-- Hero Section -->
<section class="relative overflow-hidden pt-20 pb-32 lg:pt-32 lg:pb-48 bg-surface">
<div class="max-w-screen-2xl mx-auto px-8 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
<div class="z-10">
<h1 class="text-5xl lg:text-7xl font-extrabold tracking-tight text-on-surface mb-8 leading-[1.1]">
The All-in-One ERP for <font color="#026bff">Vehicle Rental</font> &amp; Fleet Management.
</h1>
<p class="text-xl text-on-surface-variant mb-12 max-w-xl leading-relaxed">
Scale your transportation business with a unified platform designed for precision, automated compliance, and real-time operational intelligence.
</p>
<div class="flex flex-wrap gap-4">
<a routerLink="/create-account" class="bg-gradient-to-r from-primary to-primary-container text-on-primary px-8 py-4 rounded-xl font-bold text-lg shadow-xl hover:shadow-primary/20 transition-all active:scale-95">Get Started</a>
<button class="bg-surface-container-high text-on-primary-fixed-variant px-8 py-4 rounded-xl font-bold text-lg hover:bg-surface-container-highest transition-all active:scale-95">Watch Demo</button>
</div>
</div>
<div class="relative">
<div class="absolute -top-20 -right-20 w-96 h-96 bg-primary/10 rounded-full blur-3xl"></div>
<div class="relative bg-surface-container-lowest rounded-2xl p-4 shadow-[0_12px_40px_rgba(25,28,30,0.06)] transform lg:rotate-2 lg:hover:rotate-0 transition-transform duration-500">
<img class="rounded-xl w-full h-auto object-cover aspect-video" src="https://lh3.googleusercontent.com/aida-public/AB6AXuDsmD8W4KoEsh4ygziS-wUZhKGPxMikvEBj7lKcU8p9siwSKCd8NtD4Uigyuo1TwpAsTIdIXe92Cy6ReQCODQItQM89C8PPHXNLFJenJclE8F5oFWd5nSIocV_6WfBnjxuDYM3EQC8XBIuSLLRidCTohG9kcQ_P_CokE7RVGU7Inhn6wBFhF8VQ8SBvd9RHDRBeCQa_bIwXP6BQaZgQLo8NqWcQs_X9idlLjyRBwOA5mUY3aXX-nF_dKCLC4MhjcO9vBs3R4EBH4Ms"/>
</div>
</div>
</div>
</section>

<!-- Value Prop -->
<section class="py-24 bg-surface-container-low">
<div class="max-w-screen-2xl mx-auto px-8">
<div class="text-center mb-16">
<h2 class="text-4xl font-extrabold mb-4">Why Choose ZAD ERP for Rental?</h2>
<div class="h-1.5 w-20 bg-primary mx-auto rounded-full"></div>
</div>
<div class="grid grid-cols-1 md:grid-cols-3 gap-8">
<div class="bg-surface-container-lowest p-10 rounded-xl shadow-sm hover:translate-y-[-8px] transition-transform duration-300">
<div class="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center text-primary mb-8"><span class="material-symbols-outlined text-3xl">schedule</span></div>
<h3 class="text-2xl font-bold mb-4">Real-time Availability</h3>
<p class="text-on-surface-variant leading-relaxed">Instantly track every asset in your fleet across multiple locations with zero latency in booking status updates.</p>
</div>
<div class="bg-surface-container-lowest p-10 rounded-xl shadow-sm hover:translate-y-[-8px] transition-transform duration-300">
<div class="w-16 h-16 rounded-2xl bg-secondary-container flex items-center justify-center text-on-secondary-container mb-8"><span class="material-symbols-outlined text-3xl">receipt_long</span></div>
<h3 class="text-2xl font-bold mb-4">Automated Billing</h3>
<p class="text-on-surface-variant leading-relaxed">Generate complex rental invoices and recurring billing cycles automatically, reducing administrative overhead by 40%.</p>
</div>
<div class="bg-surface-container-lowest p-10 rounded-xl shadow-sm hover:translate-y-[-8px] transition-transform duration-300">
<div class="w-16 h-16 rounded-2xl bg-tertiary-fixed flex items-center justify-center text-on-tertiary-fixed mb-8"><span class="material-symbols-outlined text-3xl">build</span></div>
<h3 class="text-2xl font-bold mb-4">Fleet Maintenance</h3>
<p class="text-on-surface-variant leading-relaxed">Predictive alerts for servicing and repairs ensure your vehicles remain safe, compliant, and ready for the next client.</p>
</div>
</div>
</div>
</section>
<!-- Feature Deep-Dive -->
<section class="py-24 px-8 max-w-screen-2xl mx-auto space-y-32">
<div class="flex flex-col lg:flex-row items-center gap-16">
<div class="w-full lg:w-1/2 order-2 lg:order-1">
<div class="space-y-6">
<span class="text-primary font-bold tracking-widest text-xs uppercase">Precision Management</span>
<h2 class="text-4xl font-extrabold text-on-background">Smart Booking &amp; Rental Agreements</h2>
<p class="text-on-surface-variant text-lg leading-relaxed">Transition to a paperless environment with digital contracts that support electronic signatures and automated validation. Our booking engine handles dynamic pricing, peak-season adjustments, and customer loyalty tiers in one seamless workflow.</p>
<ul class="space-y-4">
<li class="flex items-start gap-3"><span class="material-symbols-outlined text-primary mt-1">check_circle</span><span>Instant E-Signatures</span></li>
<li class="flex items-start gap-3"><span class="material-symbols-outlined text-primary mt-1">check_circle</span><span>Automated Deposit Handling</span></li>
<li class="flex items-start gap-3"><span class="material-symbols-outlined text-primary mt-1">check_circle</span><span>Multi-point Inspection Checklists</span></li>
</ul>
</div>
</div>
<div class="w-full lg:w-1/2 order-1 lg:order-2">
<div class="relative bg-surface-container-lowest rounded-3xl p-4 shadow-2xl">
<img class="w-full h-auto rounded-2xl object-cover" src="https://lh3.googleusercontent.com/aida-public/AB6AXuBZuIw3s3RqUvhqcw1Jkl0b7nxwJa7LJC_l9jIBbwSR0iePoMZwSATZdb3D6SUYbxUJu8NynNvAMhKCW0PRenEdQwoFLdq_yJmb980TbD6rfnVEEjh6PU4MRS9e9AMx1c9N-6dZ0MJNCD3Ep7Zy5bZhzPdc8rRK16UKUSaqSMKZjWCBN7jbu1umw3JpI79aDea21GIbFSxa18Say31EhWDiutSl7O8hK_25CYuxh12C7x957rx2djrfobtKnOyJkgKNWfmZl4wN2qU"/>
</div>
</div>
</div>
<div class="flex flex-col lg:flex-row items-center gap-16">
<div class="w-full lg:w-1/2">
<div class="relative bg-surface-container-lowest rounded-3xl p-4 shadow-2xl">
<img class="w-full h-auto rounded-2xl object-cover" src="https://lh3.googleusercontent.com/aida-public/AB6AXuDkLGFOYw6035d6WVKnwUiBJf4lfJ--_RgtvOmhoBb-IBFyT5JRIN6wM_LzWI7Bh9SOUvH9EVL-SHoK9EY8ZoRcKTjkepIcEttUcPIjNQcP7myNGKtxKU1ICwSUrsSkgDr43A311pJtd8brkqvYjtXTSzrNcOPrMf06g4abQJ4Q7IOGOiLHM-1iDdQ5_DMagfoiLpDFLQCUwl289IQXXZIMlfyIUUwyH0BeKo7FGcwAYRT6NPXes_WOBly2cyavbc8yaqBZD9jS330"/>
</div>
</div>
<div class="w-full lg:w-1/2">
<div class="space-y-6">
<span class="text-primary font-bold tracking-widest text-xs uppercase">Financial Integrity</span>
<h2 class="text-4xl font-extrabold text-on-background">Complete Financial Control &amp; Invoicing</h2>
<p class="text-on-surface-variant text-lg leading-relaxed">Automate your entire financial ecosystem from ledger entries to tax compliance. TransArchitect integrates with major banking systems to provide real-time cash flow visibility and automated reconciliation for high-volume transactions.</p>
<div class="p-6 bg-surface-container-lowest rounded-xl border-l-4 border-primary shadow-sm">
<p class="italic text-on-surface-variant text-sm">"The automated ledger saved our finance team over 60 hours a month in manual data entry." — Global Logistics CFO</p>
</div>
</div>
</div>
</div>
<div class="flex flex-col lg:flex-row items-center gap-16">
<div class="w-full lg:w-1/2 order-2 lg:order-1">
<div class="space-y-6">
<span class="text-primary font-bold tracking-widest text-xs uppercase">Human Capital</span>
<h2 class="text-4xl font-extrabold text-on-background">Employee &amp; Driver Management</h2>
<p class="text-on-surface-variant text-lg leading-relaxed">Empower your team with a dedicated portal for HR and driver tracking. Monitor license expirations, working hours, and performance metrics. Built-in fatigue management tools ensure your operations remain safe and within legal parameters.</p>
<a routerLink="/create-account" class="bg-primary-container text-white px-6 py-2.5 rounded-xl font-bold text-sm hover:opacity-90 active:scale-95 transition-all flex items-center gap-2">Get Started Now<span class="material-symbols-outlined text-sm">arrow_forward</span></a>
</div>
</div>
<div class="w-full lg:w-1/2 order-1 lg:order-2">
<div class="relative bg-surface-container-lowest rounded-3xl p-4 shadow-2xl">
<img class="w-full h-auto rounded-2xl object-cover" src="https://lh3.googleusercontent.com/aida-public/AB6AXuDyZopjoa3yRlsi7skQaWaDMnwcdo-ZLOuHIN-RZKoRvQaDiBFywmj87edsd5eqHD0Kixq-bKMc6l1KgA2AcWsemsTQUIMzsnks5gQCdkhZsU5gjmWVZ2p4-j-E9tH9wIyeJjmq7zBk4ClST3hapEIavhvX1LfKzbj0tOS7NOuDQsDYeKMSB9Ne5Jh9-wiU4ooTtBY2vU4uYUh7ZXO47f2SW9bsNao4pmkkmTEt4fOVmg_tJnEFcpQ6PEDWsPDp9oY_6y9IpkbXbHE"/>
</div>
</div>
</div>
</section>

<!-- FAQ Section (Dynamically Bound) -->
<section class="py-24 bg-surface-container-low font-['Manrope']">
<div class="max-w-3xl mx-auto px-8">
<div class="text-center mb-16">
<h2 class="text-4xl font-extrabold mb-4">Frequently Asked Questions</h2>
<p class="text-on-surface-variant">Everything you need to know about our vehicle rental and transportation solutions.</p>
</div>
<div class="space-y-4">
  <details *ngFor="let faq of faqs" class="faq-accordion group bg-surface-container-lowest rounded-2xl shadow-sm overflow-hidden border border-transparent hover:border-outline-variant transition-all duration-300">
    <summary class="flex justify-between items-center p-6 cursor-pointer list-none">
    <h3 class="text-lg font-bold text-on-surface">{{faq.question}}</h3>
    <span class="faq-icon material-symbols-outlined text-primary transition-transform duration-300">expand_more</span>
    </summary>
    <div class="px-6 pb-6 text-on-surface-variant leading-relaxed">{{faq.answer}}</div>
  </details>
</div>
</div>
</section>

<!-- CTA Section -->
<section class="py-24 bg-surface">
<div class="max-w-5xl mx-auto px-8 bg-primary rounded-[2.5rem] p-16 text-center text-on-primary shadow-2xl relative overflow-hidden">
<div class="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl -mr-32 -mt-32"></div>
<div class="absolute bottom-0 left-0 w-64 h-64 bg-white/5 rounded-full blur-3xl -ml-32 -mb-32"></div>
<h2 class="text-4xl md:text-5xl font-extrabold mb-8 relative z-10">Ready to Optimize Your Fleet Operations?</h2>
<p class="text-xl opacity-90 mb-12 max-w-2xl mx-auto relative z-10">Join over 500+ transportation providers who have streamlined their business with TransArchitect Solutions.</p>
<div class="flex flex-wrap justify-center gap-4 relative z-10">
<a routerLink="/create-account" class="bg-white text-primary px-10 py-5 rounded-2xl font-bold text-lg shadow-lg hover:bg-opacity-90 active:scale-95 transition-all">Get Started Now</a>
<a routerLink="/contact" class="bg-primary-container text-white px-10 py-5 rounded-2xl font-bold text-lg shadow-lg hover:bg-opacity-90 active:scale-95 transition-all">Contact Sales</a>
</div>
</div>
</section>
